(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.em-hero-slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.em-hero-slide');
    var dots = slider.querySelectorAll('.em-hero-slider__dots button');
    if (slides.length < 2) return;

    var current = 0;
    var interval = parseInt(slider.dataset.interval, 10) || 5000;
    var timer;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function start() {
      timer = setInterval(function () {
        show(current + 1);
      }, interval);
    }

    function restart() {
      clearInterval(timer);
      start();
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.slide, 10));
        restart();
      });
    });

    // Swipe on touch devices.
    var startX = null;
    slider.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) {
        show(current + (delta < 0 ? 1 : -1));
        restart();
      }
      startX = null;
    }, { passive: true });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  });
})();
